function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 8A8 8 0 100 8a8 8 0 0016 0zM7.01 4.883A1 1 0 019.004 5v3.5h.498l.11.006a1 1 0 01.69 1.594l-1.5 2-.085.1a1 1 0 01-1.515-.1l-1.5-2-.062-.091A1 1 0 016.502 8.5h.502V5l.006-.117z",
  fill: "#243143"
});

function SvgAssembling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiA4QzE2IDMuNTgxNzIgMTIuNDE4MyAwIDggMEMzLjU4MTcyIDAgMCAzLjU4MTcyIDAgOEMwIDEyLjQxODMgMy41ODE3MiAxNiA4IDE2QzEyLjQxODMgMTYgMTYgMTIuNDE4MyAxNiA4Wk03LjAxMDM2IDQuODgzMzhDNy4wNjgxMiA0LjM4NjA0IDcuNDkwOCA0IDguMDAzNjMgNEM4LjU1NTkyIDQgOS4wMDM2MyA0LjQ0NzcyIDkuMDAzNjMgNVY4LjVIOS41MDE4Mkw5LjYxMTk0IDguNTA1NzJDMTAuMzY2NiA4LjU4NDk0IDEwLjc3MzggOS40NzA3MyAxMC4zMDE4IDEwLjFMOC44MDE4MiAxMi4xTDguNzE2NzIgMTIuMTk5NkM4LjI5NjkzIDEyLjYzMSA3LjU3NTE1IDEyLjU5NzggNy4yMDE4MiAxMi4xTDUuNzAxODIgMTAuMUw1LjY0MDMyIDEwLjAwODVDNS4yNTA4OCA5LjM1NzE4IDUuNzE1MjMgOC41IDYuNTAxODIgOC41SDcuMDAzNjNWNUw3LjAxMDM2IDQuODgzMzhaIiBmaWxsPSIjMjQzMTQzIi8+Cjwvc3ZnPgo=";
export { SvgAssembling as ReactComponent };